import dragVerify from './src/main';

dragVerify.install = function (Vue) {
  Vue.component(dragVerify.name, dragVerify);
};

export default dragVerify;



// WEBPACK FOOTER //
// ./src/packages/vue-drag-verify/index.js